import { render } from "./MyNFTs.vue?vue&type=template&id=45c46aba&scoped=true"
import script from "./MyNFTs.vue?vue&type=script&lang=js"
export * from "./MyNFTs.vue?vue&type=script&lang=js"

import "./MyNFTs.vue?vue&type=style&index=0&id=45c46aba&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c46aba"]])

export default __exports__